import { render, staticRenderFns } from "./cost-report.vue?vue&type=template&id=85833acc&scoped=true"
import script from "./cost-report.vue?vue&type=script&lang=js"
export * from "./cost-report.vue?vue&type=script&lang=js"
import style0 from "./cost-report.vue?vue&type=style&index=0&id=85833acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85833acc",
  null
  
)

export default component.exports